
$(function(){
    $(window).scroll(function (){
        $('.fadein').each(function(){
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - windowHeight + 200){
              $(this).addClass('active');
            }
        });
    });
});


$(function(){
    $(window).scroll(function (){
        $('.fadein3').each(function(){
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - windowHeight + 200){
                $(function(){
                    $('.fadein3').each(function(i){
                        $(this).delay(i * 300).queue(function(){
                            $(this).addClass('active');
                        });
                    });
                });
            }
        });
    });
});	

/*media with image*/

$(function(){
    $(window).scroll(function (){
        $('.media-with-text__media').each(function(){
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - windowHeight + 200){
              $(this).addClass('active');
            }
        });
    });
});

/*media-collage-block__media*/

$(function(){
    $(window).scroll(function (){
        $('.media-collage-block__media').each(function(){
            var position = $(this).offset().top;
            var scroll = $(window).scrollTop();
            var windowHeight = $(window).height();
            if (scroll > position - windowHeight + 200){
              $(this).addClass('active');
            }
        });
    });
});